import {
  Design,
  DesignChannelType,
  DesignModuleNodeConfig,
  LanguageCode,
  PromptObjectConfigText,
  PromptObjectConfigTtsOverrides
} from '@app/types';

export type GetPromptVoiceChannelProps = {
  promptNodeConfig: DesignModuleNodeConfig;
  serialized?: Design;
};

export function getPromptVoiceChannel({
  promptNodeConfig,
  serialized
}: GetPromptVoiceChannelProps): PromptObjectConfigTtsOverrides | PromptObjectConfigText | undefined {
  serialized ??= window.apm.serialized;
  const { ttsOverrides: ttsFlag } = serialized.rootSettings.features;
  const { isOmniChannel } = serialized.omniChannel;
  const { channel = {}, text, ttsOverrides = null } = promptNodeConfig ?? {};
  const defaultText = (
    (isOmniChannel) ? channel?.[DesignChannelType.voice] : null
  ) ?? text;

  if (!ttsFlag || !ttsOverrides) {
    return defaultText;
  }

  let voiceChannel: PromptObjectConfigTtsOverrides = {};
  Object.entries(defaultText ?? {}).forEach(([language, text = '']) => {
    const languageCode = language as LanguageCode;
    voiceChannel[languageCode] = { default: { text } };
    if (!(languageCode in ttsOverrides)) {
      return;
    }
    voiceChannel[languageCode] = {
      ...voiceChannel[languageCode],
      ...ttsOverrides[languageCode]
    };
  });
  return voiceChannel;
}
